import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.createInternalCalculator.success: {
            return action.payload;
        }


        case constants.createInternalCalculator.try:
        case constants.createInternalCalculator.error: {
            return {};
        }

        default:
            return state;
    }
}